import React from 'react';
import { Column, Columns, Inline, Stack, Text } from 'braid-design-system';
import type { MappedAdProduct } from 'src/mappers/mapProductSetItems';
import { Discount } from './Discount/Discount';
import { Free } from './Free/Free';
import { getPriceWithTax } from './getDisplayPrices';
import { Price } from './Price/Price';

export const PriceRows = ({
  mappedAdProducts,
  showDiscountInfo,
}: {
  mappedAdProducts: MappedAdProduct[];
  showDiscountInfo: boolean;
}) => {
  return (
    <Stack space="gutter">
      {mappedAdProducts.map((mappedAdProduct) => (
        <PriceRow
          mappedAdProduct={mappedAdProduct}
          showDiscountInfo={showDiscountInfo}
        />
      ))}
    </Stack>
  );
};

export const PriceRow = ({
  mappedAdProduct,
  showDiscountInfo,
}: {
  mappedAdProduct: MappedAdProduct;
  showDiscountInfo: boolean;
}) => {
  const { price, name } = mappedAdProduct;

  const totalPrice = getPriceWithTax(price, showDiscountInfo);

  const getPriceDetails = () => {
    if (totalPrice === 0) {
      return <Free name={name} />;
    }
    return (
      <Inline
        space="small"
        align="right"
        data={{ testid: `${name}_price_container` }}
      >
        <Discount
          mappedAdProduct={mappedAdProduct}
          showDiscountInfo={showDiscountInfo}
        />
        <Price
          mappedAdProduct={mappedAdProduct}
          showDiscountInfo={showDiscountInfo}
        />
      </Inline>
    );
  };

  return (
    <Columns space="xsmall" key={name}>
      <Column width="1/3">
        <Text size="standard" id={name} data={{ testid: name }}>
          {name}
        </Text>
      </Column>
      <Column>{getPriceDetails()}</Column>
    </Columns>
  );
};
